export function MiraseeBadge({ size = 'sm' }: { size?: 'sm' | 'xs' }) {
  const classes = size === 'xs' ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2.5 py-1';

  return (
    <span
      class={`inline-flex items-center gap-1 font-semibold text-[#003da6] dark:text-blue-300 bg-[#003da6]/10 dark:bg-[#003da6]/20 rounded-full leading-none ${classes}`}
    >
      <svg
        fill="currentColor"
        viewBox="0 0 20 20"
        aria-hidden="true"
        style="width: 14px; height: 14px; flex-shrink: 0"
      >
        <path
          fill-rule="evenodd"
          d="M16.403 12.652a3 3 0 000-5.304 3 3 0 00-3.75-3.751 3 3 0 00-5.305 0 3 3 0 00-3.751 3.75 3 3 0 000 5.305 3 3 0 003.75 3.751 3 3 0 005.305 0 3 3 0 003.751-3.75zm-2.546-4.46a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
          clip-rule="evenodd"
        />
      </svg>
      Mirasee
    </span>
  );
}
